import { findRemoteLog } from '../findRemoteLog';

const TRACKED_FIELDS = ['enabled', 'userId', 'groupId', 'isNative'];

/**
 * Log which input changed when raw sessionRunKey recomputes (debug → remote sink).
 */
export function logSessionRunKeyRecompute(rawKey, inputs, previous) {
  const changes = [];
  for (const field of TRACKED_FIELDS) {
    if (previous[field] !== inputs[field]) {
      changes.push({ field, from: previous[field], to: inputs[field] });
    }
  }

  findRemoteLog(
    'debug',
    'proximity.session_run_key.recompute',
    {
      rawKey,
      previousRawKey: previous.rawKey ?? null,
      changes,
    },
    { skipThrottle: true },
  );

  return { ...inputs, rawKey };
}

export function parseSessionRunKey(key) {
  if (!key) {
    return { userId: null, groupId: null };
  }
  const separator = key.indexOf(':');
  if (separator < 0) {
    return { userId: key, groupId: null };
  }
  return {
    userId: key.slice(0, separator),
    groupId: key.slice(separator + 1),
  };
}
